<template>
  <layout :bg-image-mobile="true">
    <template v-slot:header>
      <p class="sm:text-2xl sm:font-extrabold font-montserrat text-center mt-10">
        {{ $t('companyArea.accounting.voucher.title')}}
      </p>
    </template>

    <div class="panel space-y-4">
      <div class="text-base font-semibold">{{ $t('companyArea.accounting.voucher.title')}}</div>
      <p class="text-xs sm:text-sm text-gray-400">
        {{ $t('companyArea.accounting.voucher.text') }}
      </p>
      <ol class="list-decimal list-inside text-sm">
        <li>{{ $t('companyArea.accounting.voucher.step1') }}</li>
        <li>{{ $t('companyArea.accounting.voucher.step2') }}</li>
      </ol>

      <div
        class="text-base font-semibold"
        data-cy="balance-label"
      >
        {{ $t('companyArea.accounting.credit.currentSaldo') }}:
        <span
          :class="{ 'text-red-700': company.credit < 0, 'text-green-700': company.credit >= 0 }"
          data-cy="balance-amount"
        >
          <strong>{{ company.currency }} {{ company.credit }}</strong>
        </span>
      </div>

      <!-- Einlöse-Bereich -->
      <div class="mt-4 flex flex-col sm:flex-row sm:items-center sm:space-x-4 space-y-2 sm:space-y-0">
        <input
          v-model="voucherCode"
          class="flex-grow mainform-color mainform-input"
          type="text"
          placeholder="Gutschein-Code eingeben"
          :disabled="loading"
          @keyup.enter="redeemVoucher"
          data-cy="voucher-input"
        />
        <button
        class="btn btn-md btn-primary mt-3 sm:mt-0 w-full sm:w-auto block text-center" @click="redeemVoucher">{{ $t('companyArea.accounting.voucher.redeem') }}</button>
      </div>

      <!-- Feedback -->
      <div v-if="response === true" class="text-green-600 font-medium" data-cy="voucher-success">
        {{ $t(responseMessage) }}<br>
        <span class="font-semibold">{{ $t('companyArea.accounting.voucher.value') }}: {{ value.currency }} {{ value.amount }}</span>

      </div>
      <div v-else-if="response === false" class="text-red-600 font-medium" data-cy="voucher-error">
        {{ $t(responseMessage) }}
      </div>
    </div>
  </layout>
</template>

<script>
  import Layout        from '../../Layout.vue'
  import companyApi    from '../../connections/company'
  import store         from '../../store/mainStore'

  export default {
    name: 'Voucher',
    components: {
      Layout,
    },
    data() {
      return {
        voucherCode: '',
        loading:      false,
        response:     null,      // true = gültig, false = ungültig, null = noch nichts geprüft
        responseMessage: '',      // individuelles Feedback
        value: ''
      }
    },
    computed: {
      company() {
        return store.state.company.company
      }
    },
    methods: {
      async redeemVoucher() {
        if (!this.voucherCode.trim()) {
          this.response = false
          this.responseMessage = 'companyArea.accounting.voucher.noCode'
          return
        }

        this.loading = true
        this.response = null
        this.responseMessage = ''

        try {
          const res = await companyApi.patch(
            `/companies/${this.company.id}/vouchers/redeem`,
            { voucher: this.voucherCode.trim() }
          )
          // Erwartetes Rückgabeformat: { success: boolean, message: string, newCredit?: number }
          if (res.data.notificationType === 'success') {
            this.response = true
            this.responseMessage = 'companyArea.accounting.voucher.redeemed'
            this.value = res.data.content.value
            // Balance im Store aktualisieren, falls zurückgeliefert
            store.commit('company/setCredit', res.data.content.credit)

          } else {
            this.response = false
            this.responseMessage = 'companyArea.accounting.voucher.notRedeemed';
          }
        } catch (err) {
          this.response = false
          this.responseMessage = err.response?.data?.message
            || 'Beim Einlösen ist ein Fehler aufgetreten.'
        } finally {
          this.loading = false
        }
      }
    }
  }
</script>

<style scoped>
    .panel {
        @apply bg-white p-6 rounded-lg shadow-md;
    }
</style>
